export const auctionMenu = [
    { title: "Schedule", link: "/procurement/auction/schedules" },
    { title: "Live Auction", link: "/procurement/auction/live" },
    { title: "Auction Data", link: "/procurement/auction/data" },
    { title: "Quotas", link: "/procurement/auction/quotas" },
    { title: "Groups", link: "/procurement/auction/groups" }
]